import Campana from "./Campana";

export default Campana;
